import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./UserPage.css";

const BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://api.quote.softvolute.in";

const API = `${BASE_URL}/api`;

export default function UserPage() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    role: "designer",
  });

  const [users, setUsers] = useState([]);
  const [editId, setEditId] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    const res = await axios.get(`${API}/users`);
    setUsers(res.data || []);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  /* ================= CREATE / UPDATE ================= */

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (editId) {
        await axios.put(`${API}/users/${editId}`, {
          name: form.name,
          email: form.email,
          role: form.role,
        });
      } else {
        await axios.post(`${API}/users`, form);
      }

      resetForm();
      fetchUsers();
    } catch (err) {
      alert(err.response?.data?.message || "Error saving user");
    }
  };

  const handleEdit = (user) => {
    setForm({
      name: user.name,
      email: user.email,
      password: "",
      role: user.role,
    });
    setEditId(user._id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this user?")) return;
    await axios.delete(`${API}/users/${id}`);
    fetchUsers();
  };

  const resetForm = () => {
    setForm({
      name: "",
      email: "",
      password: "",
      role: "designer",
    });
    setEditId(null);
  };

  return (
    <div className="up-page">
      {/* ===== TOP BAR ===== */}
      <div className="up-top-bar">
        <button onClick={() => navigate(-1)} className="up-back-btn">
          ← Back
        </button>

        <h1 className="up-title">👥 Team Members</h1>
      </div>

      {/* ================= FORM CARD ================= */}
      <div className="up-card">
        <form onSubmit={handleSubmit} autoComplete="off" className="up-form">
          {/* Dummy hidden fields (Chrome autofill fix) */}
          <input type="text" className="up-hidden-input" />
          <input type="password" className="up-hidden-input" />

          <input
            name="name"
            placeholder="Full Name"
            value={form.name}
            onChange={handleChange}
            required
            autoComplete="off"
            className="up-input"
          />

          <input
            name="email"
            placeholder="Email"
            type="email"
            value={form.email}
            onChange={handleChange}
            required
            autoComplete="new-email"
            className="up-input"
          />

          {!editId && (
            <input
              name="password"
              placeholder="Password"
              type="password"
              value={form.password}
              onChange={handleChange}
              required
              autoComplete="new-password"
              className="up-input"
            />
          )}

          <select
            name="role"
            value={form.role}
            onChange={handleChange}
            className="up-input"
          >
            <option value="admin">Admin</option>
            <option value="designer">Designer</option>
            <option value="studio_head">Studio Head</option>
            <option value="sales_manager">Sales Manager</option>
            <option value="center_head">Center Head</option>
            <option value="project_manager">Project Manager</option>
            <option value="site_engineer">Site Engineer</option>
            <option value="accountant">Accountant</option>
            <option value="head_accountant">Accountant Head</option>
            <option value="marketing">Marketing</option>
          </select>

          <button type="submit" className="up-save-btn">
            {editId ? "Update User" : "+ Add User"}
          </button>

          {editId && (
            <button type="button" onClick={resetForm} className="up-cancel-btn">
              Cancel
            </button>
          )}
        </form>
      </div>

      {/* ================= TABLE ================= */}
      <div className="up-table-card">
        <table className="up-table">
          <thead>
            <tr className="up-table-head-row">
              <th className="up-th">Name</th>
              <th className="up-th">Email</th>
              <th className="up-th">Role</th>
              <th className="up-th up-th-center">Action</th>
            </tr>
          </thead>

          <tbody>
            {users.map((user) => (
              <tr key={user._id} className="up-row">
                <td className="up-td">{user.name}</td>
                <td className="up-td">{user.email}</td>
                <td className="up-td">{user.role}</td>
                <td className="up-td up-td-center">
                  <button
                    onClick={() => handleEdit(user)}
                    className="up-edit-btn"
                  >
                    ✏ Edit
                  </button>

                  <button
                    onClick={() => handleDelete(user._id)}
                    className="up-delete-btn"
                  >
                    🗑 Delete
                  </button>
                </td>
              </tr>
            ))}

            {users.length === 0 && (
              <tr className="up-empty-row">
                <td colSpan="4" className="up-empty">
                  No users found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
